import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import {
  actionSetCurrentCuratedPickFilterFromCache,
  actionSetCurrentFiltersFromCache,
} from '../../store/Filter/FilterAction';
import {
  actionSetCurrentSearchQueryIdFromCache,
  actionSetCurrentSearchSessionIdFromCache,
} from '../../store/Search/SearchAction';
import { useFeatureFlags } from '../../utils/useFeatureFlags';
import { actionSetRefinedSearchValuesFromCache } from '../../store/Availability/AvailabilityAction';

const SearchResultWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { refreshSearchRevampFlagIsEnabled } = useFeatureFlags();

  // Blocks user from going back until filters, session ID are set from cache
  useEffect(() => {
    return history.block((_, action) => {
      if (action === 'POP') {
        if (refreshSearchRevampFlagIsEnabled) {
          dispatch(actionSetCurrentSearchQueryIdFromCache());
          dispatch(actionSetCurrentFiltersFromCache());
          dispatch(actionSetCurrentCuratedPickFilterFromCache());
          dispatch(actionSetCurrentSearchSessionIdFromCache());
          dispatch(actionSetRefinedSearchValuesFromCache());
        } else {
          dispatch(actionSetCurrentFiltersFromCache());
          dispatch(actionSetCurrentSearchSessionIdFromCache());
        }
      }

      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return <>{children}</>;
};

export default SearchResultWrapper;
